import { ONE_MINUTE } from '@air/utilities';

import { type TranscriptStatusResponse } from '~/swr-hooks/clips/transcript/useGetPrivateClipTranscriptInfo';

const MAX_TRANSCRIPT_RANGE_IN_MINUTES = 5;

// This is the limit of the range that can be passed when fetching a transcript.
export const MAX_TRANSCRIPT_RANGE_IN_MS = MAX_TRANSCRIPT_RANGE_IN_MINUTES * ONE_MINUTE;

export const MIN_TRANSCRIPT_QUERY_LENGTH = 2;

export const TRANSCRIPT_SEARCH_DEBOUNCE_MS = 300;

type TranscriptStatus = TranscriptStatusResponse['status'];

/** Transcript statuses that indicate transcription is still in progress. */
export const TRANSCRIPT_PROGRESS_STATUSES = ['processing', 'pending'] as const satisfies readonly Exclude<
  TranscriptStatus,
  'none' | 'complete' | 'error' | 'unsupported'
>[];

export const isTranscriptProgressStatus = (
  status: TranscriptStatus | undefined,
): status is (typeof TRANSCRIPT_PROGRESS_STATUSES)[number] =>
  status !== undefined && TRANSCRIPT_PROGRESS_STATUSES.some((progressStatus) => progressStatus === status);
